const normalizeLists = (root) => {
  root.querySelectorAll('ol li[data-list="bullet"]').forEach((li) => {
    const ol = li.parentElement;
    if (!ol || ol.tagName !== "OL") return;
    const ul = document.createElement("ul");
    ol.parentNode?.insertBefore(ul, ol);
    Array.from(ol.children).forEach((child) => {
      if (child.tagName === "LI") {
        child.removeAttribute("data-list");
      }
      ul.appendChild(child);
    });
    ol.remove();
  });

  root.querySelectorAll('ul li[data-list="ordered"]').forEach((li) => {
    const ul = li.parentElement;
    if (!ul || ul.tagName !== "UL") return;
    const ol = document.createElement("ol");
    ul.parentNode?.insertBefore(ol, ul);
    Array.from(ul.children).forEach((child) => {
      if (child.tagName === "LI") {
        child.removeAttribute("data-list");
      }
      ol.appendChild(child);
    });
    ul.remove();
  });
};

const normalizeTextNodes = (root) => {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const nodes = [];
  let current = walker.nextNode();

  while (current) {
    nodes.push(current);
    current = walker.nextNode();
  }

  nodes.forEach((textNode) => {
    textNode.nodeValue = textNode.nodeValue.replace(/\u00a0/g, " ");
  });
};

export const sanitizeBlogHtml = (html, { stripStyles = false } = {}) => {
  if (!html) return "";

  const doc = new DOMParser().parseFromString(String(html), "text/html");
  doc.querySelectorAll("script,style").forEach((node) => node.remove());
  doc.querySelectorAll("[class]").forEach((node) => node.removeAttribute("class"));
  if (stripStyles) {
    doc.querySelectorAll("[style]").forEach((node) => node.removeAttribute("style"));
  }
  normalizeLists(doc.body);

  normalizeTextNodes(doc.body);

  return doc.body.innerHTML;
};

export const formatBlogDate = (value) => {
  if (!value) return "";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value).split("T")[0] || String(value);
  }

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }).format(date);
};
